/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menu_Get_ListedInputs */



/**
* | output |
* | --- |
* | "Get listed" |
*
* @param {Menu_Get_ListedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const menu_get_listed = /** @type {((inputs?: Menu_Get_ListedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menu_Get_ListedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Get listed")
});